import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer, PersistConfig } from 'redux-persist';

import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { EnvironmentType } from '../../types/environment.types.ts';

import { ENVIRONMENT_SLICE_NAME, EnvironmentSliceState } from './environment.slice.types.ts';
import { getAndAssignEnvironmentOnInitThunkExtraReducers } from './thunks/get-and-assign-environment-on-init.thunk.ts';

export const ENVIRONMENT_INITIAL_STATE: EnvironmentSliceState = {
  selectedEnvironment: undefined,
  isLoading: false,
};

const persistConfig: PersistConfig<EnvironmentSliceState> = {
  key: ENVIRONMENT_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: ['selectedEnvironment'],
};

const environmentSlice = createSlice({
  name: ENVIRONMENT_SLICE_NAME,
  initialState: ENVIRONMENT_INITIAL_STATE,
  reducers: {
    setSelectedEnvironment: (state, action: PayloadAction<EnvironmentType>) => {
      state.selectedEnvironment = action.payload;
    },
  },
  extraReducers: (builder) => {
    getAndAssignEnvironmentOnInitThunkExtraReducers(builder);
  },
});

export const { setSelectedEnvironment } = environmentSlice.actions;

export const EnvironmentSlice = persistReducer(persistConfig, environmentSlice.reducer);
